import { addError } from "@wayflyer/blackbox-fe";
import type { ConnectionSchemas } from "api-types";
import { requestPost } from "shared-utils";

import { analytics } from "../../analytics";

/**
 * To complete the connection on click of "Connect" in the complete connection modal
 */
export const completeConnection = async (
  completeConnectionPath: string,
  props: ConnectionSchemas.CompleteConnectionPropsSchema,
  context: any,
  payload?: any,
  toaster?: any
) => {
  try {
    //TODO: update to axios
    await requestPost(completeConnectionPath, { ...props, ...payload });
    analytics.updateOnboardingState(props, context);
    window.location.replace(window.location.pathname + `?connectionSucceed=${props.dataSourceSlug}`);
  } catch (e) {
    addError(e);
    toaster?.critical(e);
  }
};

/**
 * To cancel a connection from the confirmation modal on click of "Cancel"
 */
export const cancelConnection = async (
  cancelConnectionPath: string,
  props: ConnectionSchemas.CompleteConnectionPropsSchema,
  context: any,
  toaster?: any
) => {
  try {
    await requestPost(cancelConnectionPath, props);
    analytics.updateOnboardingState(props, context);
    window.location.replace(window.location.pathname);
  } catch (e) {
    addError(e);
    toaster?.critical(e);
  }
};

/**
 * Used to init oAuth with the value from dataSource.connectPath
 * and to complete connectByPost ops using response.authUrl
 */
export const connectByPath = (path) => {
  const url = /^((http|https):\/\/)/;
  if (!url.test(path)) {
    path = `${window.location.protocol}//${window.location.host + path}`;
  }
  window.location.href = path;
  /**
   * Resolving this promise on page load ensures
   * that the button working state remains until
   * the page transition completes
   */
  return new Promise((resolve) => {
    window.onload = () => resolve(undefined);
  });
};
